export default {
    selectedTrack: {
        title: "", parent: { title: "", covers: {} }
    },
    mostListened: []
}